import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose, empty } from 'ramda';
import { Video, Container } from './videoSlide.styles';
import { EntityRefData } from '../../../../shared/components/entityRefData';

const IMAGE_SIZES = [160, 384, 640, 960];

export class VideoSlideComponent extends PureComponent {
  static propTypes = {
    video: PropTypes.string,
    image: PropTypes.string,
    isActive: PropTypes.bool,
    onSlideEnded: PropTypes.func,
  };

  static defaultProps = {
    onSlideEnded: empty,
  };

  state = {
    isVisible: false,
  };

  componentDidMount() {
    this.checkIsVisible();
  }

  componentDidUpdate(prevProps) {
    this.checkIsVisible();
    if (!prevProps.isActive && this.props.isActive) {
      this.videoRef.current.currentTime = 0;
      this.videoRef.current.play();
    }

    if (prevProps.isActive && !this.props.isActive) {
      this.videoRef.current.pause();
    }
  }

  checkIsVisible = () => {
    const isVisible = this.rootRef.current && this.rootRef.current.matches('.slick-current *');
    this.setState({ isVisible });
  };

  videoRef = React.createRef();
  rootRef = React.createRef();

  handleEnded = () => this.props.onSlideEnded();

  renderVideo = video => (
    <EntityRefData id={this.props.image}>
      {({ file } = {}) => (
        <Video
          disableViewportDetection
          playerRef={this.videoRef}
          file={video}
          playsInline
          autoPlay={this.state.isVisible}
          muted
          controls={false}
          preload="none"
          poster={file}
          posterProps={{
            imgProps: { sizes: '50vw' },
            sizes: IMAGE_SIZES,
          }}
          onEnded={this.handleEnded}
        />
      )}
    </EntityRefData>
  );

  render() {
    const { video } = this.props;

    return (
      <Container ref={this.rootRef}>
        <EntityRefData id={video}>{({ file }) => this.renderVideo(file)}</EntityRefData>
      </Container>
    );
  }
}

export const VideoSlide = compose(injectIntl)(VideoSlideComponent);
